import { Module } from 'vuex';
import { RootState } from '@/store';
import { enterprises } from './enterprises';
import { products } from '@/store/models/pub/products';

export const pub: Module<RootState, any> = {
  namespaced: true,
  modules: {
    enterprises: enterprises,
    products: products
  }
};
